module.exports = __webpack_public_path__ + "static/media/my-avatar.9ba7f600.jpg";